import type { PermissionCheckInput } from './PermissionCheckInput.tsx';

const getServiceDeskSiteAri = (cloudId: string): string =>
	`ari:cloud:jira-servicedesk::site/${cloudId}`;
const getJiraSiteAri = (cloudId: string): string => `ari:cloud:jira::site/${cloudId}`;
const getAssetsSiteAri = (cloudId: string): string => `ari:cloud:cmdb::site/${cloudId}`;

/**
 * The permission checks whose resource ARI is derived purely from `cloudId`.
 * These can be resolved in a single preloaded query because their variables are
 * known synchronously (no dependency on the Assets Vertical workspace ARI).
 */
export const getStaticPermissionChecks = (cloudId: string): PermissionCheckInput[] => [
	// Jira Service Desk user
	{ resourceId: getServiceDeskSiteAri(cloudId), permissionId: 'write' },
	// Jira admin
	{ resourceId: getJiraSiteAri(cloudId), permissionId: 'manage' },
	// Assets admin
	{ resourceId: getAssetsSiteAri(cloudId), permissionId: 'manage' },
];
